// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"084c2e05","834":"fc4d6371","840":"7ec01861"}[chunkId] + ".chunk.js";
};